import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
import { useState } from "react";

const TenderSearchBar = ({
  handleSubmitSearch,
  title,
  setCurrentPage,
  setSearchTerm,
}) => {
  const [text, setText] = useState(""); // Local state to track input
  const { getText } = useLanguageTranslation();

  return (
    <div className="form-group">
      <div className="form-inline">
        <input
          placeholder={title}
          className="form-control tender-search"
          autoComplete="off"
          type="text"
          id="edit-title"
          name="title"
          size="30"
          maxLength="128"
          value={text} // Controlled input field
          onChange={(e) => setText(e.target.value)}
        />
        <button
          className="ml-2 quick-btn quick-100"
          type="submit"
          onClick={() => handleSubmitSearch(text)} // Pass the text state value on submit
        >
          {getText("Submit", "सबमिट")}
        </button>
        <button
          className="quick-btn clear-btn ml-2"
          type="reset"
          onClick={() => {
            setText("");
            setCurrentPage(0);
            setSearchTerm("");
          }} // Clear the input on reset
        >
          {getText("Clear", "हटाएँ")}
        </button>
      </div>
    </div>
  );
};

export default TenderSearchBar;
